export const hasInvitedLevelOverride = match => Boolean(
  match &&
  match.currentUserInvited &&
  match.currentUserLevelCompatible === false
);
